import { CButton } from '@coreui/react'
import React from 'react'


const TableTitle = ({ onClickOpenModal, mnemoButton }) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <CButton disabled={mnemoButton} onClick={onClickOpenModal} style={{ alignItems: 'end' }} size='sm' className='text-light'>
                Добавить
            </CButton>
        </div>
    )
}

export default TableTitle